var exports = {
  "kL": "x2b2fbebb--317ac6--container",
  "DD": "x2b2fbebb--317ac6--title",
  "Ud": "x2b2fbebb--317ac6--overall-rating",
  "VQ": "x2b2fbebb--317ac6--ratings",
};

module.exports = exports;
